import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLang } from "../../context/LangContext";
import { ContactForm } from "./ContactForm";
import { LogoMark } from "./Logo";

export const ContactDialog = ({ type, onClose }) => {
  const { t } = useLang();
  const investor = type === "investor";
  const consulting = type === "consulting";
  const title = investor ? t.form.investorTitle : consulting ? t.form.consultingTitle : t.form.projectTitle;
  const sub = investor ? t.form.investorSub : consulting ? t.form.consultingSub : t.form.projectSub;
  return (
    <Dialog open={!!type} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-lenis-prevent
        data-testid={investor ? "investor-deck-modal" : consulting ? "consulting-modal" : "contact-modal"}
        className="max-h-[92vh] max-w-2xl overflow-y-auto rounded-[28px] border border-[#d4af37]/25 bg-[#0d0d0f] p-8 text-[#fafaf7] sm:rounded-[28px] md:p-12 [&>button]:text-white/60"
      >
        <LogoMark className="h-10 w-10" />
        <DialogTitle className="mt-6 font-display text-3xl font-bold tracking-tight md:text-4xl">
          {title}
        </DialogTitle>
        <DialogDescription className="mb-4 text-sm text-white/55 md:text-base">
          {sub}
        </DialogDescription>
        {type && <ContactForm type={type} prefix={investor ? "investor" : consulting ? "consulting" : "modal"} onSuccess={onClose} />}
      </DialogContent>
    </Dialog>
  );
};
